import { render } from "./FileUploadForm.vue?vue&type=template&id=5708effe&scoped=true"
import script from "./FileUploadForm.vue?vue&type=script&lang=js"
export * from "./FileUploadForm.vue?vue&type=script&lang=js"

import "./FileUploadForm.vue?vue&type=style&index=0&id=5708effe&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-5708effe"

export default script